import React, { Component, Fragment } from "react";
import ContainerDimensions from "react-container-dimensions";
import PropTypes from "prop-types";
import BacktestService from "../../../../service/backtest.service";
import HomeChart from "../../../../helper/homechart.helper";
import Pie from "../../../../helper/piechart.helper";
import Spinner from "../../../common/spinner";
import NoDataToDisplay from "../../../common/errorBoundary/noDataAvailable";
import WithCard from "../../../common/withCard";
import DownloadPdfButton from "../../../common/buttons/downloadPdfButton";
import AreaChartWithAxis from "../../../d3Components/multiAreaChart/AreaChartWithAxis";
import Legend from "../../../d3Components/legend";
import PDFHelper from "../../../parts/pdfmaker/pdf.helper";
import {
  StyleSheet,
  Image as IMG,
  View,
  Document,
  Page,
  Text,
  pdf,
} from "@react-pdf/renderer";
import { pdfStyles } from "../Component page/pdf.styles";
import PdfHeader from "../../../parts/pdfmaker/common/pdfHeader";
import pdfLegend from "../../../parts/pdfmaker/common/pdfLegend";
import CustomBarChartWithCircle from "../../../d3Components/customBarchartWithCircle";
import "./simulation.scss";

class Simulation extends Component {
  state = {
    getMontecarloData: [],
    getMontecarloMetrics: [],
    getStressTestData: [],
    stressTestMinVal: null,
    stressTestMaxVal: null,
    pies: [],
    rolling_area_portfolio: [],
    rolling_area_benchmark: [],
    spinner: false,
    monte_carlo_api_failed: false,
    stress_test_api_fail: false,
    stress_test_loading: false,
    pdf_legends: ["Portfolio", "Benchmark"],
    colors: ["#81efde", "#4c6ead", "#8775a7"],
  };
  async componentDidMount() {
    const {
      scenarioID,
      dt,
      getBacktest,
      type,
      analyzeExistingActive,
      clientPortfolioID,
    } = this.props;

    if (analyzeExistingActive == false) {
      // montecarlo api call
      this.setState({
        spinner: true,
      });

      await BacktestService.getMontecarlo(scenarioID)
        .then((res) => {
          if (res) {
            this.setState({
              getMontecarloData: res.getMontecarloData,
              getMontecarloMetrics: res.getMontecarloMetrics,
              spinner: false,
              monte_carlo_api_failed: false,
            });
            this.handleMontecarloData(res);
          }
        })
        .catch((err) => {
          this.setState({
            spinner: false,
            monte_carlo_api_failed: true,
          });
        });
    }
    // getStress test
    if (dt) {
      this.setState({
        stress_test_loading: true,
      });
      await BacktestService.getStressTest({
        id: scenarioID,
        rtype: "BACKTEST",
        dt: dt,
        cid: clientPortfolioID,
      })
        .then((res) => {
          if (res) {
            let minMaxValues = this.getMinAndMaxOFStressTest({ data: res });
            console.log("minMax", minMaxValues);
            this.setState({
              getStressTestData: res,
              stress_test_api_fail: false,
              stress_test_loading: false,
              stressTestMinVal: minMaxValues["min"],
              stressTestMaxVal: minMaxValues["max"],
            });
          }
        })
        .catch((err) => {
          console.log(err, "getStressTest , ------error--------");
          this.setState({
            stress_test_api_fail: true,
            stress_test_loading: false,
          });
        });
    }

    if (
      type &&
      type.toUpperCase() == "LIVE" &&
      getBacktest &&
      getBacktest.getPortfolioVami &&
      getBacktest.getPortfolioVami.length > 0
    ) {
      let drawDownData = this.modifyDrawDownChartData({
        getPortfolioVami: getBacktest.getPortfolioVami,
      });
      this.setState({
        rolling_area_portfolio: drawDownData["portfolio"],
        rolling_area_benchmark: drawDownData["benchmark"],
      });
    }
  }
  async componentWillReceiveProps(nextProps) {
    const {
      scenarioID,
      getBacktest,
      type,
      analyzeExistingActive,
      clientPortfolioID,
    } = nextProps;
    const { getStressTestData } = this.state;

    if (this.props.scenarioID != scenarioID && analyzeExistingActive == false) {
      this.setState({
        spinner: true,
      });
      await BacktestService.getMontecarlo(scenarioID)
        .then((res) => {
          if (res) {
            this.setState({
              getMontecarloData: res.getMontecarloData,
              getMontecarloMetrics: res.getMontecarloMetrics,
              spinner: false,
              monte_carlo_api_failed: false,
            });
            this.handleMontecarloData(res);
          }
        })
        .catch((err) => {
          this.setState({
            spinner: false,
            monte_carlo_api_failed: true,
          });
        });
    }

    // getStress test
    // if (
    //   (getStressTestData && getStressTestData.length == 0) ||
    //   this.props.scenarioID != scenarioID
    // ) {
    //   this.setState({
    //     stress_test_loading: true,
    //   });
    // }
    if (
      (getStressTestData &&
        getStressTestData.length == 0 &&
        this.props.dt != nextProps.dt) ||
      this.props.scenarioID != scenarioID
    ) {
      this.setState({
        stress_test_loading: true,
      });
      await BacktestService.getStressTest({
        id: scenarioID,
        rtype: "BACKTEST",
        dt: nextProps.dt,
        cid: clientPortfolioID,
      })
        .then((res) => {
          if (res && res.length > 0) {
            let minMaxValues = this.getMinAndMaxOFStressTest({ data: res });
            this.setState({
              getStressTestData: res,
              stress_test_api_fail: false,
              stress_test_loading: false,
              stressTestMinVal: minMaxValues["min"],
              stressTestMaxVal: minMaxValues["max"],
            });
          } else {
            this.setState({
              stress_test_loading: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            stress_test_api_fail: true,
            stress_test_loading: false,
          });
        });
    }

    if (
      type &&
      type.toUpperCase() === "LIVE" &&
      getBacktest &&
      getBacktest.getPortfolioVami
    ) {
      let drawDownData = this.modifyDrawDownChartData({
        getPortfolioVami: getBacktest.getPortfolioVami,
      });
      this.setState({
        rolling_area_portfolio: drawDownData["portfolio"],
        rolling_area_benchmark: drawDownData["benchmark"],
      });
    }
  }

  handleMontecarloData = (data) => {
    this.setState(
      {
        pies: [
          {
            name: "5th percentile Return %",
            value: data.getMontecarloMetrics[0]["5_perc_return"],
            percent: "5%",
          },
          {
            name: "25th percentile Return %",
            value: data.getMontecarloMetrics[0]["25_perc_return"],
            percent: "25%",
          },
          {
            name: "50th percentile Return %",
            value: data.getMontecarloMetrics[0]["50_perc_return"],
            percent: "50%",
          },
          {
            name: "5th percentile drawdown %",
            value: (
              +data.getMontecarloMetrics[0]["5_perc_value"] * 100
            ).toFixed(2),
            percent: "5%",
          },
          {
            name: "25th percentile drawdown %",
            value: (
              +data.getMontecarloMetrics[0]["50_perc_value"] * 100
            ).toFixed(2),
            percent: "25%",
          },
          {
            name: "50th percentile drawdown %",
            value: (
              +data.getMontecarloMetrics[0]["50_perc_value"] * 100
            ).toFixed(2),
            percent: "50%",
          },
        ],
      },
      () => {
        setTimeout(() => {
          Pie.renderPies(".easy-pie-chart .number");
        }, 1000);
      }
    );

    this.renderMontecarlo(data);
  };
  renderMontecarlo = (data) => {
    const series = [];
    const metrics = [];
    for (let i in data.getMontecarloData) {
      series.push([
        +data.getMontecarloData[i].index,
        +data.getMontecarloData[i].value,
      ]);
    }

    metrics.push(
      [
        +data.getMontecarloMetrics[0]["5_perc_return"],
        +data.getMontecarloMetrics[0]["5_perc_value"],
      ],
      [
        +data.getMontecarloMetrics[0]["25_perc_return"],
        +data.getMontecarloMetrics[0]["25_perc_value"],
      ],
      [
        +data.getMontecarloMetrics[0]["50_perc_return"],
        +data.getMontecarloMetrics[0]["50_perc_value"],
      ]
    );

    HomeChart.renderScatterChart("#curr_goal_metrics_simulation", series);
  };

  getMinAndMaxOFStressTest = ({ data } = []) => {
    if (!data) return {};
    let list = [];

    for (let i = 0; i < data.length; i++) {
      list.push(data[i]["bm_return"], data[i]["fund_return"]);
    }
    list.sort((a, b) => a - b);

    return { min: list[0], max: list[list.length - 1] };
  };
  modifyDrawDownChartData = ({ getPortfolioVami }) => {
    if (!getPortfolioVami || getPortfolioVami.length == 0)
      return { portfolio: [], benchmark: [] };

    let portfolio = [];
    let benchmark = [];

    for (let i = 0; i < getPortfolioVami.length; i++) {
      let p = {};
      let b = {};
      let bm = getPortfolioVami[i]["rollingvol_bm_90"] * 1;
      let fund = getPortfolioVami[i]["rollingvol_fund_90"] * 1;

      if (bm && fund) {
        p["dt"] = getPortfolioVami[i]["dt"];
        b["dt"] = getPortfolioVami[i]["dt"];

        p["drawdown"] = fund;
        b["drawdown"] = bm;

        portfolio.push(p);
        benchmark.push(b);
      }
    }
    return { portfolio, benchmark };
  };

  exportToPDF = () => {
    const {
      pdf_legends,
      colors,
      getStressTestData,
      rolling_area_portfolio,
      rolling_area_benchmark,
    } = this.state;
    const { analyzeExistingActive, type } = this.props;
    const heading = this.props.heading
      ? this.props.heading
      : "CREATE PORTFOLIO";

    let promiseList = [PDFHelper.svgToPng("curr_goal_metrics_simulation")];
    let display_rolling_90_chart = false;
    if (
      type &&
      type.toUpperCase() === "LIVE" &&
      rolling_area_portfolio &&
      rolling_area_portfolio.length &&
      rolling_area_benchmark &&
      rolling_area_benchmark.length
    ) {
      display_rolling_90_chart = true;
      promiseList.push(PDFHelper.svgToPng("simulation_areachart"));
    }

    let scenario_start_idx =
      analyzeExistingActive === true
        ? 0
        : analyzeExistingActive === false && display_rolling_90_chart
        ? 2
        : 1;
    // add scenario analysis if data present
    if (getStressTestData && getStressTestData.length > 0) {
      for (let i = 0; i < getStressTestData.length; i++) {
        let p = PDFHelper.svgToPng(
          `customBarChartWithCircle-${getStressTestData[i]["stress_test_id"]}`
        );
        promiseList.push(p);
      }
    }
    Promise.allSettled([...promiseList]).then((values) => {
      const styles = StyleSheet.create({
        ...pdfStyles,
      });
      const MyDoc = () => (
        <Document>
          <Page size="A4" wrap style={styles.pb}>
            <PdfHeader mainHeading={heading + " - " + "SIMULATION"} />
            <View style={styles.paddingHorizontal}>
              {values[0].value && values[0] ? (
                <View>
                  <View
                    style={{
                      color: "#223279",
                      textAlign: "center",
                      paddingTop: 5,
                      paddingBottom: 5,
                    }}
                  >
                    <Text>SIMULATION</Text>
                  </View>
                  <View>
                    <IMG source={values[0].value}></IMG>
                  </View>
                </View>
              ) : null}
              {display_rolling_90_chart && values[1].value ? (
                <View style={{ marginTop: 50 }}>
                  <View
                    style={{
                      color: "#223279",
                      textAlign: "center",
                      paddingTop: 5,
                      paddingBottom: 5,
                    }}
                  >
                    <Text>ROLLING 90 DAY VOLATILITY</Text>
                  </View>

                  <View>
                    {pdfLegend({ colors: colors, data_list: pdf_legends })}
                  </View>
                  <IMG source={values[1].value}></IMG>
                </View>
              ) : null}

              {getStressTestData && getStressTestData.length > 0 ? (
                <View style={{ marginTop: 10 }}>
                  <View
                    style={{
                      textAlign: "center",
                      paddingTop: 5,
                      paddingBottom: 5,
                    }}
                  >
                    <Text style={{ color: "#223279" }}>SCENARIO ANALYSIS</Text>
                    <Text style={{ coloe: "#696969" }}>
                      Stress tested comparison of Benchmark vs Portfolio
                    </Text>
                  </View>

                  {getStressTestData.map((stressTest, idx) => (
                    <View key={idx}>
                      {values[scenario_start_idx + idx] &&
                        values[scenario_start_idx + idx].value && (
                          <Fragment>
                            <View>
                              {pdfLegend({
                                colors: colors,
                                data_list: pdf_legends,
                              })}
                            </View>
                            <IMG
                              source={values[scenario_start_idx + idx].value}
                            ></IMG>
                          </Fragment>
                        )}
                    </View>
                  ))}
                </View>
              ) : null}
            </View>
          </Page>
        </Document>
      );
      pdf(<MyDoc />)
        .toBlob()
        .then((blob) => {
          const link = document.createElement("a");
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = "simulation.pdf";
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
        });
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.scenarioID !== this.props.scenarioID ||
      nextProps.dt !== this.props.dt ||
      nextProps.clientPortfolioID !== this.props.clientPortfolioID
    ) {
      console.log("=================simulation tab===================");
      console.log(nextProps, nextState);
      console.log(this.props, this.state);
      console.log("======================================");
      return true;
    } else {
      return true;
    }
  }
  render() {
    const {
      spinner,
      monte_carlo_api_failed,
      pies,
      rolling_area_portfolio,
      rolling_area_benchmark,
      getStressTestData,
      stress_test_loading,
      stress_test_api_fail,
      stressTestMinVal,
      stressTestMaxVal,
    } = this.state;
    const { type, analyzeExistingActive } = this.props;
    return (
      <div className="simulation">
        {console.log("===========render simulation=================")}
        <Fragment>
          {/* {(!spinner && !monte_carlo_api_failed) ||
            (analyzeExistingActive == false && ( */}
          <WithCard>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto component_pdf_btn">
                <DownloadPdfButton handler={this.exportToPDF} />
              </div>
            </div>
          </WithCard>
          {/* ))} */}

          {analyzeExistingActive == false ? (
            <WithCard>
              <div className="row">
                {spinner ? <Spinner /> : null}
                {monte_carlo_api_failed ? <NoDataToDisplay /> : null}
                {!spinner && !monte_carlo_api_failed ? (
                  <div className="col-md-12">
                    <h4 className="text-uppercase bold">
                      Monte carlo simulation
                    </h4>
                  </div>
                ) : null}
                <div className="col-md-6">
                  <div
                    id="curr_goal_metrics_simulation"
                    style={{ width: "100%", height: "300px" }}
                  ></div>
                </div>
                <div className="col-md-6">
                  <div className="portlet-body">
                    <div className="row">
                      {pies.map((pie, i) => (
                        <div key={i} className="col-md-4">
                          <div className="easy-pie-chart">
                            <div
                              className="number"
                              data-percent={pie.percent}
                              data-color={pie.color}
                            >
                              <span>{pie.value}</span>
                            </div>
                            <span className="title">{pie.name}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </WithCard>
          ) : null}

          {/* rolling 90 days area chart */}
          {type &&
          type.toUpperCase() == "LIVE" &&
          rolling_area_portfolio &&
          rolling_area_portfolio.length &&
          rolling_area_benchmark &&
          rolling_area_benchmark.length ? (
            <WithCard>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div>
                    <h4 className="text-uppercase bold">
                      Rolling 90 Day Volatility
                    </h4>
                  </div>
                  <ContainerDimensions>
                    {({ width }) => (
                      <Fragment>
                        {width > 0 ? (
                          <Fragment>
                            <Legend
                              height={30}
                              width={width}
                              legend1={"Portfolio"}
                              legend2={"Benchmark"}
                            />
                            <AreaChartWithAxis
                              id="simulation_areachart"
                              height={400}
                              width={width - 100}
                              Benchmark={rolling_area_benchmark}
                              Portfolio={rolling_area_portfolio}
                              getOrigPortfolioVami={false}
                              display_orig_portfolio={false}
                            />
                          </Fragment>
                        ) : null}
                      </Fragment>
                    )}
                  </ContainerDimensions>
                </div>
              </div>
            </WithCard>
          ) : null}

          {/* scenario analysis chart */}
          {stress_test_loading ? (
            <WithCard>
              <Spinner />
            </WithCard>
          ) : null}

          {stress_test_api_fail ? (
            <WithCard>failed to load data</WithCard>
          ) : null}
          {getStressTestData && getStressTestData.length > 0 ? (
            <WithCard>
              <Fragment>
                <div style={{ textAlign: "center", marginBottom: "15px" }}>
                  <h4 className="text-uppercase bold">SCENARIO ANALYSIS</h4>
                  <div
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      marginTop: "-15px",
                    }}
                  >
                    Stress tested comparision of Client Portfolio vs Selected
                    Model
                  </div>
                </div>
                <ContainerDimensions>
                  {({ width }) => (
                    <Fragment>
                      {width > 0 &&
                        getStressTestData.map((test, idx) => (
                          <div
                            key={`key-${test.stress_test_id}`}
                            className="simulation__CustomBarChartWithCircle"
                          >
                            <CustomBarChartWithCircle
                              id={`customBarChartWithCircle-${test.stress_test_id}`}
                              width={width <= 1024 ? width : width * 0.7}
                              height={400}
                              label1="Client"
                              label2="Model"
                              fund_return={test.fund_return}
                              bm_return={test.bm_return}
                              bar_float={idx % 2 === 0 ? "right" : "left"}
                              stress_test_id={test.stress_test_id}
                              stress_test_name={test.stress_test_name}
                              bg_color={idx % 2 === 0 ? true : false}
                              min={stressTestMinVal}
                              max={stressTestMaxVal}
                            />
                          </div>
                        ))}
                    </Fragment>
                  )}
                </ContainerDimensions>
              </Fragment>
            </WithCard>
          ) : null}
        </Fragment>
      </div>
    );
  }
}

Simulation.propTypes = {
  scenarioID: PropTypes.number.isRequired,
  dt: PropTypes.string.isRequired,
  analyzeExistingActive: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  getBacktest: PropTypes.object,
};
export default Simulation;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/simulation/simulation.jsx